import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* changeOrderStatus(action) {
  try {
    yield call(() => callGetAPI(SERVER_API.CHANGE_ORDER_STATUS, action.data));
    yield put({ type: sagaActions.ORDERS_LOAD_REQUEST });
  } catch (e) {
    yield put({ type: sagaActions.API_FAILED, message: e.message });
  }
}

function* watchOrderStatusAsync() {
  yield takeLatest(sagaActions.ORDERS_STATE_CHANGE_REQUEST, changeOrderStatus);
}

export default watchOrderStatusAsync;
